<script setup lang="ts">
import { computed } from 'vue'
import { useShowroomStore } from '../store/showroom'

const store = useShowroomStore()

const logoAsset = computed(() => store.getAsset('company-bf-logo'))
const skylineAsset = computed(() => store.getAsset('company-industrial-cityline'))
const qrAsset = computed(() => store.getAsset('company-wechat-qr'))
</script>

<template>
  <section v-if="store.company.value" class="company-view">
    <div class="company-hero">
      <div class="company-hero-copy">
        <img
          v-if="logoAsset"
          class="company-logo"
          :src="store.mediaUrl(logoAsset)"
          :alt="logoAsset.altText"
        />
        <p class="eyebrow">CONTROL SYSTEM PROFESSIONAL SERVICE</p>
        <h2>{{ store.company.value.tagline }}</h2>
        <p>{{ store.company.value.summary }}</p>

        <div v-if="store.company.value.facts?.length" class="company-facts">
          <div v-for="fact in store.company.value.facts" :key="fact.label">
            <strong>{{ fact.value }}</strong>
            <span>{{ fact.label }}</span>
          </div>
        </div>
      </div>

      <img
        v-if="skylineAsset"
        class="company-skyline"
        :src="store.mediaUrl(skylineAsset)"
        :alt="skylineAsset.altText"
      />
    </div>

    <div class="company-section-heading">
      <div>
        <p class="eyebrow">SERVICE SCOPE</p>
        <h3>六类专业服务能力</h3>
      </div>
      <p>围绕客户核心诉求，提供覆盖实施、检测、运维和创新应用的一站式控制系统解决方案。</p>
    </div>

    <div class="capability-grid">
      <article
        v-for="capability in store.company.value.capabilities"
        :key="capability.domain"
      >
        <span>{{ capability.domain.toUpperCase() }}</span>
        <h3>{{ capability.title }}</h3>
        <p>{{ capability.description }}</p>
      </article>
    </div>

    <div v-if="store.company.value.values?.length" class="company-values">
      <p class="eyebrow">OUR VALUES</p>
      <div>
        <span v-for="value in store.company.value.values" :key="value">{{ value }}</span>
      </div>
      <strong>专业服务 · 创造价值</strong>
    </div>

    <div class="company-contact">
      <div>
        <p class="eyebrow">CONTACT</p>
        <h3>联系必服</h3>
        <p>真诚地为用户设想</p>
      </div>
      <dl>
        <div v-if="store.company.value.contact.name">
          <dt>联系人</dt>
          <dd>{{ store.company.value.contact.name }}</dd>
        </div>
        <div v-if="store.company.value.contact.phone">
          <dt>电话</dt>
          <dd>{{ store.company.value.contact.phone }}</dd>
        </div>
        <div v-if="store.company.value.contact.website">
          <dt>官网</dt>
          <dd>{{ store.company.value.contact.website }}</dd>
        </div>
        <div v-if="store.company.value.contact.email">
          <dt>邮箱</dt>
          <dd>{{ store.company.value.contact.email }}</dd>
        </div>
        <div v-if="store.company.value.contact.address">
          <dt>地址</dt>
          <dd>{{ store.company.value.contact.address }}</dd>
        </div>
      </dl>
      <div v-if="qrAsset" class="company-qr">
        <img :src="store.mediaUrl(qrAsset)" :alt="qrAsset.altText" />
        <span>微信扫码联系</span>
      </div>
    </div>
  </section>
</template>
